import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import AppRouter from './routers/AppRouter';

Sentry.init({dsn: 'https://933fc81e4c1e4baa95c593fe238fdb40@sentry.io/1858537'});

// Load the router, which loads the proper page(s)
ReactDOM.render(<AppRouter />, document.getElementById('app'));
